"use strict";

(function (global) {

  /**
   * Фабрика отчетов.
   * Предоставлет инструменты для работы с отчетами. Например, для формирования аналитического или интегрированного отчета.
   *
   * @namespace WebAccess.factories.reports
   * @property {OBJECT_TYPE} WebAccess.factories.reports.contentType Тип содержимого фабрики
   * @since 5.0.0.7300
   */

  var Report = WA.FC.BaseFactory.extend({
    className: "ReportFactory",
    contentType: OBJECT_TYPE.REPORT,
    reportName: '',

    init: function (reportName) {
      if (!reportName) {
        WA.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED', 'reportName');
      }
      this.reportName = reportName;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Генерирует отчет.
     *
     * @method WebAccess.factories.reports.execute
     * @param {Object} dialog Диалог.
     * @param {Object} [referenceRecord] Ссылка на запись справочника.
     * @param {boolean} [hideError=false] Признак скрытия ошибок.
     * @return {Deferred<Object>} Отчет.
     * @private
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.0.0.7300
     */
    _execute: function (dialog, referenceRecord, hideError = false) {
      var me = this;

      if (referenceRecord) {
        dialog.requisites.integratedReportRefereneceRecordId = referenceRecord.id;
        dialog.requisites.integratedReportRefereneceCode = referenceRecord.referenceName;
      }

      var proxyCall = $.Deferred();

      me.fire(me['class'].EVENT.BEFORE_EXECUTING, me);

      WA.SRV.request('/Report.asmx/Generate', {ReportName: me.reportName, SerializedForm: dialog}, {hideError: hideError}).done(function (guid) {
        var deprecatedObject = {
          download: function () {
            var url = new WA.URL('/download.ashx');
            url.setParam('accesstype', 'private');
            url.setParam('id', guid);
            url.setParam('name', me.reportName);
            url.open();
          },

          openByAgent: function () {
            RequestToken(TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY, function (token) {
              var requestParams = {
                id: guid,
                Token: token,
                Repository: "FileSystem",
                DownloadTool: "Handler",
                loc: document.location.host,
                secure: (document.location.protocol == 'http:' ? 'n' : 'y'),
                name: me.reportName
              };
              WA.agent.transmitRequest('opendocument', 'DocumentPlugin', requestParams).fail((response) => {
                ShowError(response.message);
              });
            });
          },

          open: function () {
            var self = this;
            if (WA.agent.isAvailable()) {
              WA.agent.isPluginAvailable('DocumentPlugin').always((isAvailableResponse) => {

                if (isAvailableResponse) {
                  self.openByAgent();
                } else {
                  self.download();
                }
              });
            } else {
              self.download();
            }
          }
        };

        proxyCall.resolve(deprecatedObject);
      }).fail(function (ex) {
        if (!ex) ex = L('ERROR_WHILE_GENERATING_REPORT');

        proxyCall.reject(ex);
      });

      return proxyCall;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сформировать отчет.
     *
     * @method WebAccess.factories.reports.execute
     * @param {Object|WebAccess.components.dialogs.FormDialog} [params] Параметры отчета или экземпляр диалога для копирования реквизитов диалога в параметры сценария.
     * @param {boolean} [transformMultiselectToDetailRows=false] Необходимость преобразования реквизита множественного выбора в строки детального раздела.
     * @return {deferred} Специальный deferred-объект.
     * @since 5.0.0.7300
     *
     * @example <caption>Запустить отчет и открыть его в новом окне.</caption>
     * WebAccess.factories.reports("WATestTest").execute({Работник: 123213}).done(function(report) {
     *   report.open();
     * });
     */
    execute(params, transformMultiselectToDetailRows = false) {
      return this._execute(this._getParams(params, transformMultiselectToDetailRows));
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сформировать интегрированный отчет.
     *
     * @method WebAccess.factories.reports.executeIntegrated
     * @param {WA.Link} [referenceRecord] Ссылка на объект записи справочника
     * @param {Object|WebAccess.components.dialogs.FormDialog} [opt_params] Параметры отчета или экземпляр диалога для копирования реквизитов диалога в параметры сценария.
     * @return {deferred} Специальный deferred-объект.
     * @since 5.0.0.7300
     *
     * @example <caption>Запустить интегрированный отчет «Использование записи справочника» из справочника «Поручения по РКК».</caption>
     * var referenceRecord =  new WA.Link(132632,OBJECT_TYPE.REFERENCE_RECORD, 'RRCAssignments');
     * WebAccess.factories.reports('Использование записи справочника').executeIntegrated(referenceRecord).done(function(report) {
    *   report.open();
    * }).fail(function(error) {
    *   alert(error);
    * });
     */
    executeIntegrated: function (referenceRecord, opt_params) {
      if (!!referenceRecord
        && referenceRecord.className == 'Link'
        && referenceRecord.type === OBJECT_TYPE.REFERENCE_RECORD) {

        return this._execute(this._getParams(opt_params, false), referenceRecord);
      } else {
        WA.raise('ERROR_INVALID_PARAMETER', referenceRecord);
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сформировать отчет с предварительным показом диалога.
     *
     * @method WebAccess.factories.reports.showDialogAndExecute
     * @param {string} dialogName Имя диалога.
     * @param {boolean} isModal Отображение диалога в виде модального окна.
     * @return {Deferred<Object>} Отчет.
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.0.0.1900
     *
     * @example <caption>Запустить отчет и открыть его в новом окне.</caption>
     * WebAccess.factories.reports("WATestTest").execute('DialogName').done(function(report) {
    *   report.open();
    * });
     */
    showDialogAndExecute(dialogName, isModal) {
      let def = $.Deferred();
      this._showDialog(dialogName, isModal).done((dialog) => {
        this.execute(dialog, true).done((report) => {
          def.resolve(report);
        }).fail((error) => {
          def.reject(error);
        });
      }).fail(() => {
        def.reject(DIALOG_ACTION.CANCEL);
      });
      return def.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сформировать интегрированный отчет.
     *
     * @method WebAccess.factories.reports.showDialogAndExecuteIntegrated
     * @param {WA.Link} [referenceRecord] Ссылка на объект записи справочника.
     * @param {string} [dialogName] Имя диалога.
     * @return {Deferred<Object>} Отчет.
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.0.0.1900
     *
     * @example <caption>Запустить интегрированный отчет «Использование записи справочника» из справочника «Поручения по РКК».</caption>
     * var referenceRecord =  new WA.Link(132632,OBJECT_TYPE.REFERENCE_RECORD, 'RRCAssignments');
     * WebAccess.factories.reports('Использование записи справочника').showDialogAndExecuteIntegrated(referenceRecord, 'DialogName').done(function(report) {
    *   report.open();
    * }).fail(function(error) {
    *   alert(error);
    * });
     */
    showDialogAndExecuteIntegrated: function (referenceRecord, dialogName, opt_isModal) {
      var me = this;
      var def = $.Deferred();
      me._showDialog(dialogName, opt_isModal).done(function (dialog) {
        me.executeIntegrated(referenceRecord, dialog).done(function (report) {
          def.resolve(report);
        }).fail(function (error) {
          def.reject(error);
        });
      }).fail(function () {
        def.reject(DIALOG_ACTION.CANCEL);
      });
      return def.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отображает диалог.
     *
     * @method WebAccess.factories.reports._showDialog
     * @private
     * @return {Deferred<Object>} Диалог.
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.0.0.1900
     */
    _showDialog: function (dialogName, opt_isModal) {
      var def = $.Deferred();
      var me = this;

      if (dialogName) {
        // Отображение диалога.
        WA.FC.dialogs.getObjectByName(dialogName, MODEL.FULL).done(function (dialog) {
          if (opt_isModal === false)
            dialog.modal = false;

          dialog.show();
          dialog.setTitle(L('REPORT_ASKABLE_PARAMS'));

          dialog.bind(WA.CMP.dialogs.FormDialog.EVENT.AFTER_ACTION, function (dialogActionName, result) {
            if (dialogActionName === DIALOG_ACTION.OK) {
              def.resolve(dialog);
            } else {
              me.fire(me['class'].EVENT.ABORT_FILLING_PARAMS, me);
            }
          });
        });
      } else {
        def.resolve(null);
      }
      return def.promise();
    },

    /**
     * Сформировать отчет с предварительным запросом параметров.
     *
     * @method WebAccess.factories.reports.queryParamsAndExecute
     * @param {Object|WebAccess.components.dialogs.FormDialog} [isModal] Отображение диалога запроса параметров в виде модального окна.
     * @param {boolean} [hideError] Признак скрытия ошибок.
     * @return {Deferred<void>}
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.2.0.1931-beta
     */
    queryParamsAndExecute(isModal, hideError) {
      let def = $.Deferred();

      this._queryParams(null, isModal).done((dialog) => {
        this._execute(dialog, null, hideError).done((report) => {
          def.resolve(report);
        }).fail((ex) => {
          def.reject(ex);
        });
      }).fail((ex) => {
        def.reject(ex);
      });

      return def.promise();
    },

    /**
     * Сформировать интегрированный отчет с предварительным запросом параметров.
     *
     * @method WebAccess.factories.reports.queryParamsAndExecuteIntegrated
     * @param {WA.Link} [referenceRecord] Ссылка на объект записи справочника.
     * @param {Object|WebAccess.components.dialogs.FormDialog} [opt_isModal] Отображение диалога запроса параметров в виде модального окна.
     * @return {Deferred<void>}
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.2.0.1931-beta
     */
    queryParamsAndExecuteIntegrated: function (referenceRecord, opt_isModal) {
      if (!!referenceRecord
        && referenceRecord.className === 'Link'
        && referenceRecord.type === OBJECT_TYPE.REFERENCE_RECORD) {

        var me = this;
        var def = $.Deferred();

        me._queryParams(referenceRecord, opt_isModal).done(function (dialog) {
          me._execute(dialog, referenceRecord).done(function (report) {
            def.resolve(report);
          }).fail(function (ex) {
            def.reject(ex);
          });
        }).fail(function (ex) {
          def.reject(ex);
        });

        return def.promise();
      } else {
        WA.raise('ERROR_INVALID_PARAMETER', referenceRecord);
        return null;
      }
    },

    /**
     * Заполнить параметры в соответствии с настройками веб-модуля (из даилога, из xml).
     *
     * @method _queryParams
     * @param {Object} referenceRecord Модель записи справочника.
     * @param {boolean} isModal Признак отображения диалога запроса параметров в модальном окне.
     * @private
     * @return {Deferred<void>}
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.2.0.1931-beta
     */
    _queryParams(referenceRecord, isModal) {
      let def = $.Deferred();

      WA.SRV.call('/report.asmx/GetReportDialogName', {ReportName: this.reportName}).done((res) => {
        if (res && res.length) {
          this._showDialog(res, isModal).done((dialog) => {
            def.resolve(this._getParams(dialog, true));
          }).fail((ex) => {
            def.reject(ex);
          });
        } else {
          this._queryParamsFromXml(referenceRecord, isModal).done((dialog) => {
            def.resolve(this._getParams(dialog, false));
          }).fail((ex) => {
            def.reject(ex);
          });
        }
      }).fail((ex) => {
        def.reject(ex);
      });

      return def.promise();
    },

    /**
     * Заполнить параметры из xml.
     *
     * @method _queryParamsFromXml
     * @param {Object} [opt_referenceRecord] Запись справочника.
     * @param {boolean} [opt_isModal] Признак модального окна.
     * @return {Deferred<void>}
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.2.0.1931-beta
     */
    _queryParamsFromXml: function (opt_referenceRecord, opt_isModal) {
      var def = $.Deferred();
      var me = this;
      var params = {name: this.reportName};

      if (opt_referenceRecord) {
        params.id = opt_referenceRecord.id;
        params.refcode = opt_referenceRecord.referenceName;
      }

      // На сервере строится разметка модалки со всеми нужными параметрам.
      WA.SRV.call("/ModalWindow.asmx/Create", {
        ControlName: 'report_params',
        Params: $.toJSON(params)
      }).done(function (res) {

        // Если параметров нет то в классе ReportParams.vb не передается контрол с ИД ReportParamsModalWindow.
        if ($(res.html).find('#ReportParamsModalWindow').length > 0) {
          var dialog = new WA.components.dialogs.ReportParamsDialog({}, {
            FormHtml: res.html,
            // ModalWindow возвращает модалки для многих объектов, а не только для отчетов, а возвращает он объек состоящий из 2 свойств
            // html и initJs. Html нам подходит, а вот в initJs напихано много всего ненужного и он строка, поэтому мы просто добавляем туда нужную
            // нам информаию (описание всех реквизитов) после ключа 'FormData:' и обрезаем строку.
            FormData: res.initJs.substring(res.initJs.indexOf('FormData:') + 9)
          });

          if (opt_isModal === false)
            dialog.modal = false;

          // Если закрыли модалку не по ОК то просто ничего не делаем.
          dialog.bind(dialog['class'].EVENT.AFTER_CLOSE_BY_OK, function () {
            dialog.validateForm();
            def.resolve(dialog);
          });

          dialog.bind(dialog['class'].EVENT.AFTER_CLOSE_BY_CANCEL, function () {
            me.fire(me['class'].EVENT.ABORT_FILLING_PARAMS, me);
          });

          dialog.bind(dialog['class'].EVENT.BEFORE_CLOSE_BY_CROSS, function () {
            me.fire(me['class'].EVENT.ABORT_FILLING_PARAMS, me);
          });

          dialog.show();
        } else {
          def.resolve(null);
        }
      }).fail(function (res) {
        def.reject(res);
      });

      return def.promise();
    },

    /**
     * Парсит параметры диалога.
     * @returns {} Сериализованная форма диалога.
     * @since 5.2.0.1931-beta
     */
    _getParams(params, transformMultiReqsToDetailRows) {
      let serializeForm = {
        tables: {},
        requisites: {},
        details: {},
      };

      if (params) {
        if (params.className === 'FormDialog' || params.className === 'ReportParamsDialog') {

          serializeForm = params.form.serialize({
            onlyValue: true,
            useRowNumber: true,
            withoutTables: true,
            transformMultiReqsToDetailRows: transformMultiReqsToDetailRows,
          });
        } else {
          for (let param in params) {
            serializeForm.requisites[param] = params[param];
          }
        }
      }

      return serializeForm;
    }
  }, {
    EVENT: {
      /**
       * Срабатывает перед началом генерации отчета.
       * @event Core.report.EVENT.BEFORE_EXECUTING
       * @since 5.2.0.1931-beta
       */
      BEFORE_EXECUTING: 'beforeExecuting',

      /**
       * Срабатывает при нажатии кнопки "Отмена" в окне запрашиваемых параметров.
       * @event Core.report.EVENT.ABORT_FILLING_PARAMS
       * @since 5.2.0.1934-beta
       */
      ABORT_FILLING_PARAMS: 'abortFillingParams'
    }
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.factories.reports = function (reportName) {
    return new Report(reportName);
  };

  global.factories.reports.getReportByName = function (reportName) {
    WA.raise('NOT_IMPLEMENTED');
    return $.Deferred;
  };

  /**
   * Получает список отчетов по коду модуля.
   *
   * @method WebAccess.factories.reports.getReportsByUnitName
   * @param {string} moduleCode Код модуля.
   * @returns {Deferred<Array<Array<string>>>} Список отчетов.
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.factories.reports.getReportsByUnitName = function (moduleCode) {
    let result = $.Deferred();
    WA.SRV.call('/Report.asmx/GetReportsByUnit', {
      UnitName: moduleCode
    }).done(res => {
      result.resolve(res);
    }).fail(errorMessage => {
      result.reject(errorMessage);
    });
    return result.promise();
  };

  /**
   * Отображает список отчетов по коду модуля.
   *
   * @method WebAccess.factories.reports.showReportsByUnitName
   * @param {string} moduleCode Код модуля.
   * @param {string} [opt_moduleName] Наименование модуля, отображаемое в окне со списком отчетов.
   * @param {number} [opt_width] Ширина окна в пикселях.
   * @param {number} [opt_height] Высота окна в пикселях.
   */
  global.factories.reports.showReportsByUnitName = (moduleCode, opt_moduleName, opt_width, opt_height) => {
    global.factories.reports.getReportsByUnitName(moduleCode).done((reports) => {
      if (reports.length) {
        let title = opt_moduleName ? L('UNIT_REPORTS', opt_moduleName) : L('REPORTS');

        let dialog = new WA.CMP.dialogs.BaseDialog();
        dialog.setTitle(title);
        dialog.width = opt_width || 600;
        dialog.height = opt_height || 400;
        dialog.isShowCancelButton = true;
        dialog.bind('OnAfterOpen', () => {
          let model = {
            items: reports.map((report) => {
              return {
                description: report[1],
                onClick: () => {
                  ShowReportParams(report[0], null, null, report[1]);
                }
              };
            })
          };

          ReactDOM.render(
            React.createElement(Component.ReportList, model),
            dialog._jContent[0]);
        });
        dialog.show();
      } else {
        ShowWarning(opt_moduleName ? L('UNIT_REPORTS_NOT_FOUND', opt_moduleName) : L('REPORTS_NOT_FOUND'));
      }
    });
  };

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess);